(() => {
  'use strict';
  if (document.getElementById('pocket-sparkle-layer')) return;
  const desktop = matchMedia('(min-width: 761px) and (hover: hover) and (pointer: fine)');
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const layer = document.createElement('div');
  layer.id = 'pocket-sparkle-layer';
  layer.setAttribute('aria-hidden', 'true');
  document.body.append(layer);
  const active = new Set();
  let lastTime = -Infinity;
  let lastPoint = null;
  const enabled = () => desktop.matches && !reduced.matches && !document.hidden;

  function clear() {
    active.forEach(item => { item.animation.cancel(); item.node.remove(); });
    active.clear();
    lastPoint = null;
    lastTime = -Infinity;
  }

  function move(event) {
    if (!enabled() || event.pointerType !== 'mouse' || event.buttons) return;
    const now = performance.now();
    if (now - lastTime < 40) return;
    if (lastPoint && Math.hypot(event.clientX - lastPoint.x, event.clientY - lastPoint.y) < 7) return;
    lastTime = now;
    lastPoint = { x: event.clientX, y: event.clientY };
    if (active.size >= 18) return;
    const node = document.createElement('span');
    node.className = 'pocket-cursor-sparkle';
    node.textContent = '✦';
    node.style.left = `${event.clientX}px`;
    node.style.top = `${event.clientY}px`;
    node.style.fontSize = `${12 + Math.random() * 9}px`;
    layer.append(node);
    if (!node.animate) { node.remove(); return; }
    const drift = (Math.random() - 0.5) * 22;
    const spin = (Math.random() - 0.5) * 80;
    const animation = node.animate([
      { opacity: 0.95, transform: 'translate(-50%, -50%) scale(.8) rotate(0deg)' },
      { opacity: 0.8, transform: `translate(calc(-50% + ${drift * .4}px), -70%) scale(1.1) rotate(${spin * .4}deg)`, offset: .25 },
      { opacity: 0, transform: `translate(calc(-50% + ${drift}px), -130%) scale(.15) rotate(${spin}deg)` }
    ], { duration: 560, easing: 'ease-out', fill: 'forwards' });
    const item = { node, animation };
    active.add(item);
    animation.onfinish = () => { node.remove(); active.delete(item); };
  }

  document.addEventListener('pointermove', move, { passive: true });
  document.addEventListener('pointerleave', clear);
  window.addEventListener('blur', clear);
  window.addEventListener('pagehide', clear);
  document.addEventListener('visibilitychange', clear);
  desktop.addEventListener('change', clear);
  reduced.addEventListener('change', clear);
})();
